import React, { useState, useEffect } from 'react';
import AfficheModal from '../components/admin/AfficheModal';

const API = process.env.REACT_APP_BACKEND_URL;

// Iter 266 (Kamel) — Page « Lien en bio » pour TikTok (24 000 abonnés) :
// tous les voyages ouverts, inscription en 2 clics. Mobile-first, sombre, rapide.
export default function BioLinks() {
  const [groups, setGroups] = useState(null);
  // Iter 267 — raccourci affiche : visible uniquement si Kamel est connecté à l'admin
  const [isAdmin, setIsAdmin] = useState(false);
  const [affiche, setAffiche] = useState(null);

  useEffect(() => {
    document.title = 'RAAV — Nos voyages ✈️';
    try { setIsAdmin(!!localStorage.getItem('admin_auth')); } catch { /* privé */ }
    fetch(`${API}/api/bio-links`)
      .then(r => r.json())
      .then(d => setGroups(d.groups || []))
      .catch(() => setGroups([]));
  }, []);

  return (
    <div className="min-h-screen py-8 px-4" style={{ background: 'linear-gradient(180deg, #0d1f38 0%, #1E3A5F 60%, #16304e 100%)' }}
      data-testid="bio-page">
      <div className="max-w-md mx-auto">
        {/* En-tête */}
        <div className="text-center mb-6">
          <img src="/icons/icon-192.png" alt="RAAV" className="w-20 h-20 rounded-full mx-auto border-4 border-white/20 shadow-xl" />
          <h1 className="text-white font-extrabold text-xl mt-3">Rhône Alpes Amitié Voyages</h1>
          <p className="text-sky-300 text-xs mt-1 font-semibold">Voyages en groupe au départ de Lyon 🚌 ✈️</p>
        </div>

        {/* Boutons rapides */}
        <div className="grid grid-cols-3 gap-2 mb-6">
          <a href="/inscription?src=bio" className="bg-white text-[#1E3A5F] rounded-xl py-2.5 text-center text-xs font-extrabold shadow hover:scale-[1.03] transition-transform" data-testid="bio-btn-inscription">📝 S'inscrire</a>
          <a href="https://wa.me/33660416218" target="_blank" rel="noreferrer" className="bg-[#25D366] text-white rounded-xl py-2.5 text-center text-xs font-extrabold shadow hover:scale-[1.03] transition-transform" data-testid="bio-btn-whatsapp">💬 WhatsApp</a>
          <a href="/" className="bg-white/10 text-white border border-white/25 rounded-xl py-2.5 text-center text-xs font-extrabold hover:bg-white/20 transition" data-testid="bio-btn-site">🌍 Le site</a>
        </div>

        {/* Voyages */}
        <h2 className="text-white/80 text-xs font-bold uppercase tracking-widest mb-3">✈️ Nos prochains voyages</h2>
        {groups === null ? (
          <p className="text-white/50 text-sm text-center py-8">Chargement…</p>
        ) : groups.length === 0 ? (
          <p className="text-white/60 text-sm text-center py-8">Aucun voyage ouvert pour le moment — reviens vite ! 🌍</p>
        ) : (
          <div className="space-y-3">
            {groups.map(g => (
              <div key={g.group} className="bg-white rounded-2xl overflow-hidden shadow-xl" data-testid={`bio-voyage-${g.group.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>
                {g.photo && (
                  <div className="h-28 relative">
                    <img src={g.photo} alt={g.group} className="w-full h-full object-cover" loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                    <p className="absolute bottom-2 left-3 text-white font-extrabold text-sm drop-shadow">{g.group}</p>
                    {g.tout_complet && <span className="absolute top-2 right-2 text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-600 text-white">COMPLET</span>}
                    {isAdmin && (
                      <button onClick={() => {
                        const d0 = g.dates.find(x => !x.complet) || g.dates[0];
                        setAffiche({
                          type: 'lancement', format: 'vertical',
                          destination: g.group, dates: d0 ? `${d0.label} 2026` : '',
                          prix: g.prix_min ? `${g.prix_min} €` : '',
                          transport: d0?.transport?.toLowerCase().includes('sans') ? 'Sans transport (sur place)' : 'Transport en autocar inclus',
                          image_url: g.photo || '',
                        });
                      }}
                        className="absolute top-2 left-2 text-[11px] font-bold px-2 py-1 rounded-full bg-purple-600/90 text-white shadow hover:bg-purple-700"
                        title="Créer l'affiche TikTok de ce voyage (visible uniquement par toi, admin)"
                        data-testid={`bio-affiche-${g.group.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>🎨 Affiche</button>
                    )}
                  </div>
                )}
                <div className="p-3">
                  {!g.photo && <p className="font-extrabold text-sm text-[#1E3A5F] mb-1">{g.group}{g.tout_complet && <span className="ml-2 text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-600 text-white">COMPLET</span>}</p>}
                  {g.detail && <p className="text-[11px] text-gray-500 mb-2">{g.detail}</p>}
                  <div className="flex flex-wrap gap-1.5 mb-2.5">
                    {g.dates.slice(0, 6).map(d => (
                      <span key={d.id} className={`text-[10px] font-bold px-2 py-1 rounded-full border ${d.complet
                        ? 'bg-gray-100 text-gray-400 border-gray-200 line-through'
                        : 'bg-sky-50 text-[#1E3A5F] border-sky-200'}`}>
                        {d.label}{d.transport ? (d.transport.toLowerCase().includes('sans') ? ' 🚗' : ' 🚌') : ''}
                      </span>
                    ))}
                    {g.dates.length > 6 && <span className="text-[10px] text-gray-400 font-bold px-1 py-1">+{g.dates.length - 6} dates</span>}
                  </div>
                  <div className="flex items-center justify-between">
                    {g.prix_min ? <p className="text-xs font-extrabold text-[#1E3A5F]">dès {g.prix_min} €</p> : <span />}
                    {g.tout_complet ? (
                      <a href="/inscription?src=bio" className="text-[11px] font-bold px-3 py-1.5 rounded-full bg-amber-100 text-amber-800 border border-amber-300">✋ Liste d'attente</a>
                    ) : (
                      <a href="/inscription?src=bio" className="text-[11px] font-extrabold px-4 py-1.5 rounded-full bg-[#1E3A5F] text-white hover:bg-[#2d4d77] transition" data-testid={`bio-cta-${g.group.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>
                        Je m'inscris →
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <p className="text-center text-white/40 text-[10px] mt-8">
          Association Rhône Alpes Amitié — Lyon · <a href="/" className="underline">rhoneamitievoyages.fr</a>
        </p>
      </div>
      {/* Iter 267 — Générateur d'affiches (admin uniquement) */}
      {isAdmin && <AfficheModal open={!!affiche} onClose={() => setAffiche(null)} initial={affiche || {}} />}
    </div>
  );
}
